import { render, staticRenderFns } from "./editBrand.vue?vue&type=template&id=30d791b1&scoped=true"
import script from "./editBrand.vue?vue&type=script&lang=js"
export * from "./editBrand.vue?vue&type=script&lang=js"
import style0 from "./editBrand.vue?vue&type=style&index=0&id=30d791b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d791b1",
  null
  
)

export default component.exports